import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import PillNavigation from "../../../components/SubNavBar";
import { Card, CardBody } from "react-bootstrap";
import { TabContent, TabPane } from "reactstrap";
import BreadCrumbs from "../../../components/BreadCrumbs";
import "./index.css";
import { NAV_LIST_CART_PERSON_VIEW } from "../../../constants/constans";
import BankDetails from "./BankDetails";
import CartPersonDetails from "./CartPersonDetails";
import Wallet from "./Wallet";

const CartPersonView = () => {
  const location = useLocation();

  const [active, setActive] = useState(1);
  const toggle = (tab: any) => {
    setActive(tab);
  };
  const cartPerson = location.state?.cartPerson;
  return (
    <>
      <BreadCrumbs hasSubMenus={true} />
      <br />
      <Card className="cart-view-whole-card">
        <CardBody>
          <div className="Cart-view-nav-bar">
            <PillNavigation
              navList={NAV_LIST_CART_PERSON_VIEW}
              active={active}
              toggle={toggle}
            />
          </div>
          <hr />
          <TabContent activeTab={active} className="mt-4">
            {active === 1 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={1}>
                  <CartPersonDetails cartPerson={cartPerson} />
                </TabPane>
              </div>
            )}
            {active === 2 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={2}>
                  <Wallet cartPerson={cartPerson} />
                </TabPane>
              </div>
            )}
            {active === 3 && (
              <div className="sub-nav-bar-each-part">
                <TabPane tabId={3}>
                  <BankDetails cartPerson={cartPerson} />
                </TabPane>
              </div>
            )}
          </TabContent>
        </CardBody>
      </Card>
    </>
  );
};

export default CartPersonView;
